import { ResponseContainer } from './DisplayContainer';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import { dateFnsLocales } from 'lib/utils/getDateFnsLocales';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const daysOfWeek = {
  SUN: 'Sunday',
  MON: 'Monday',
  TUE: 'Tuesday',
  WED: 'Wednesday',
  THU: 'Thursday',
  FRI: 'Friday',
  SAT: 'Saturday',
};

const DateDisplay = (props) => {
  const { value, includeTime } = props;
  const { t, i18n } = useTranslation();

  return (
    <ResponseContainer>
      {typeof value === 'string' ? (
        <SDiv>
          {format(parseISO(value), includeTime ? 'PPPp' : 'PPP', {
            locale: dateFnsLocales[i18n.language],
          })}
        </SDiv>
      ) : (
        <>
          <SLikertDiv>{`${t('Year')}: ${value?.year || '-'}`}</SLikertDiv>
          <SLikertDiv>{`${t('Month')}: ${
            value?.month ? t(months[value?.month - 1]) : '-'
          }`}</SLikertDiv>
          <SLikertDiv> {`${t('Day')}: ${value?.day || '-'}`}</SLikertDiv>
          <SLikertDiv>{`${t('Day of week')}: ${
            value?.dayOfWeek ? t(daysOfWeek[value?.dayOfWeek]) : '-'
          }`}</SLikertDiv>
        </>
      )}
    </ResponseContainer>
  );
};

export default DateDisplay;

const SDiv = styled.div`
  && {
    margin: 0 5px;
  }
`;

const SLikertDiv = styled.div`
  && {
    margin: 5px;
  }
`;
